import DefaultView from 'nette-front-module/js/views/front.default'
import merge from 'lodash/merge'
import Cookies from 'js-cookie'
import $ from 'cash-dom'

export default merge({
  methods: {
    toggleFilter () {
      if (this.filterOpened) {
        this.$store.dispatch('nette/updateDataKey', { data: false, key: 'filterOpened' })
      } else {
        this.$store.dispatch('nette/updateDataKey', { data: true, key: 'filterOpened' })
        Cookies.remove('gd_f')
      }
    },
    resetFilter () {
      Cookies.remove('gd_f')
      this.$store.commit('nette/updateControl', {
        controlName: 'frm-filterForm-gd_cilova_skupina',
        data: [],
        key: "val"
      })
      this.$store.commit('nette/updateControl', {
        controlName: 'frm-filterForm-gd_mistni_pusobnost',
        data: [],
        key: "val"
      })
      this.$store.commit('nette/updateControl', {
        controlName: 'frm-filterForm-gd_vyhlasovatel_skupina',
        data: [],
        key: "val"
      })
      this.$store.commit('nette/updateControl', {
        controlName: 'frm-filterForm-gd_zamereni',
        data: [],
        key: "val"
      })
      this.$store.commit('nette/updateControl', {
        controlName: 'frm-filterForm-pouze_prubezne',
        data: false,
        key: "val"
      })
      this.$store.commit('nette/updateControl', {
        controlName: 'frm-filterForm-pouze_aktualni',
        data: false,
        key: "val"
      })
      // this.$store.dispatch('nette/updateDataKey', { data: true, key: 'filterOpened' })
      this.$nextTick(() => {
        $('form#frm-filterForm .submit-filter-form').trigger('click')
      })
    }
  }
}, DefaultView)
